<template>
	<div class="nqt-container">
		<h2
			class="nqt-container-title"
			:style="`border-bottom:1px solid ${$appColors.gray};color:${$appColors.info}`"
		>Nuevo tipo de respuesta</h2>
		<form class="mt-3">
			<label :style="`color:${$appColors.info}`">
				Nombre
				<input
					class="new-survey-input" 
					placeholder="Nombre"
					v-model="newAnswer.name"
				/>
			</label>
			<label :style="`color:${$appColors.info}`">
				Tipo
				<multi-selector
					label="Tipo"
					reference="nqt-multiselect"
					class="mode"
					prop="title"
					:options="types"
					:value="newAnswer.type"
					@input="selecting"
				/>
			</label>
			<label
				class="new-question-number"
				:style="`color:${$appColors.info}`"
			>
				# Alternativas
				<input
					class="new-survey-input new-question-number-input" 
					placeholder="4"
					v-model.number="newAnswer.number"
				/>
			</label>
		</form>
		<div class="nqt-btn"
			:style="`border-top:1px solid ${$appColors.gray};`"
		>
			<app-button
				:disabled="$v.$invalid"
				:bg-color="$appColors.success"
				class="btn-tool"
				text="Crear"
				@click="setBasicAnswerData"
			></app-button>
		</div>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';
import MultiSelect from 'multiselect-dl';
import multiSelector from '@/components/shared/multi-selector';
import { required, minValue } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

function selecting({ selected }) {
	this.newAnswer.type = selected;
}

function setBasicAnswerData() {
	this.$store.dispatch('answer/setBasicData', this.newAnswer);
}

function flagEdit(val) {
	if (val) {
		this.newAnswer = {
			name: this.answerName,
			number: this.answerNumber,
			type: [this.types.find(t => t.id === this.answerType)],
		};
	}
}

function validations() {
	return {
		newAnswer: {
			name: { required },
			number: { required, minValue: minValue(1) },
			type: { required },
		},
	};
}

function data() {
	return {
		newAnswer: {
			name: '',
			number: 1,
			type: null,
		},
		types: [
			{ id: 1, title: 'Con imágenes' },
			{ id: 2, title: 'Radio' },
			{ id: 3, title: 'Selector' },
			{ id: 4, title: 'No especificado' },
		],
	};
}

export default {
	name: 'new-answer-type',
	components: {
		appButton,
		MultiSelect,
		multiSelector,
	},
	computed: {
		...mapState('answer', {
			flagEdit: state => !!state.editingAnswerId,
			answerName: state => state.partial.name,
			answerNumber: state => state.partial.number,
			answerType: state => state.partial.type,
		}),
	},
	data,
	methods: {
		setBasicAnswerData,
		selecting,
	},
	validations,
	watch: {
		flagEdit,
	},
};
</script>
<style lang="scss" scoped>
.nqt-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: inherit;

	.nqt-container-title {
		font-size: size(xlarge);
		padding: 10px 30px;
	}

	form {
		height: inherit;
		padding: 0 30px;

		label {
			font-size: size(small);
			margin-right: 10px;

			input {
				margin-bottom: 20px;
			}

			input::placeholder {
				font-size: size(medium);
			}
		}

		.new-question-number {
			align-items: center;
			display: flex;
			width: 50%;
			white-space: nowrap;

			.new-question-number-input {
				padding: 6px !important;
				margin-bottom: 0;
				margin-left: 12px;
			}
		}
	}

	.nqt-btn {
		align-items: center;
		display: flex;
		justify-content: center;
		padding: 10px 30px;
	}

}
</style>


// WEBPACK FOOTER //
// src/components/configuration/answer/new-answer-type.vue